import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "student/:studentId",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "transcripts-curriculum-student" */ "./components"
    ).then(m => m.default)
  ),
  childRoutes: [],
});
